import { cardAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(cardAnatomy.keys);

const baseStyle = definePartsStyle({
  list: {
    my: "14px",
    borderRadius: "0px",
  },
});

const ChakraUIMenuStyling = defineMultiStyleConfig({ baseStyle });

export default ChakraUIMenuStyling;
